import i18n from '@/lib/language'
const getMembers = (id) => {
  // const maps = {
  //   'key_1': '销售人员',
  //   'key_2': '销售主管',
  //   'key_3': '公海成员',
  //   'key_4': '负责人',
  //   'key_5': '公海负责人',
  //   'key_6': '信息接待主管',
  //   'key_7': '信息接待',
  //   'key_8': '开发人员',
  //   'key_9': '信息开发组长',
  //   'key_10': '信息开发主管'
  // }
  const maps = {
    'key_-1': i18n.t('message["302"]'),
    'key_1': i18n.t('message["373"]'),
    'key_2': i18n.t('message["1047"]'),
    'key_3': i18n.t('message["549"]'),
    'key_4': i18n.t('message["1338"]'),
    'key_5': i18n.t('message["1231"]'),
    'key_6': i18n.t('message["1333"]'),
    'key_7': i18n.t('message["1227"]'),
    'key_9': i18n.t('message["330"]'),
    'key_10': i18n.t('message["410"]')
  }
  return maps[`key_${id}`] || ''
}
const getType = (id) => {
  const maps = {
    'key_1': i18n.t('message["1291"]'),
    'key_2': i18n.t('message["720"]'),
    'key_3': i18n.t('message["238"]'),
    'key_4': i18n.t('message["251"]'),
    'key_5': i18n.t('message["1500"]'),
    'key_6': i18n.t('message["1254"]')
  }
  return maps[`key_${id}`] || ''
}

const getClassVal = (tabName) => {
  const maps = {
    'system': '1',
    'wechat': '2',
    'dingtalk': '3',
    'sms': '4',
    'email': '5',
    'wexin': '6'
  }
  return maps[tabName] || ''
}

export { getMembers, getType, getClassVal }
